<div class="wrapper">
  <div
    class="vehicleTitle"
    [class.vehicleTitleMobile]="isMobile"
    [class.borderBottom]="!isClosed && workSpace.cargoSpaces[cargoSpaceIndex].groups.length > 0"
    (click)="changeCurrentWorkSpace(workSpaceIndex)"
    >
    <div class="container">
      @if (workSpace) {
        <div class="vehicleTypeWrapper">
          <div class="indexWorkSpace" data-ctx="label-workspace-index">
            <span>{{ workSpaceIndex + 1 }}</span>
          </div>
          <div class="iconWrapper">
            @if (workSpace.cargoSpaces[0].type === 1 && !workSpace.cargoSpaces[1]) {
              <gl-icon
                [name]="'semi-trailer'"
                class="vehicle"
              ></gl-icon>
            }
            @if (workSpace.cargoSpaces[0].type === 1 && workSpace.cargoSpaces[1]) {
              <div
                class="setTruckIcon"
                >
                <gl-icon
                  [name]="'trailer'"
                  class="vehicleSet"
                  [class.iconCargoDeactive]="cargoSpaceIndex === 0"
                ></gl-icon>
                <gl-icon
                  [name]="'semi-trailer'"
                  class="vehicle"
                  [class.iconCargoDeactive]="cargoSpaceIndex === 1"
                ></gl-icon>
              </div>
            }
            @if (workSpace.cargoSpaces[0].type === 2) {
              <gl-icon
                [name]="'type-container'"
                class="vehicle"
              ></gl-icon>
            }
            @if (workSpace.cargoSpaces[0].type === 3) {
              <gl-icon
                [name]="'palette'"
                class="vehicle"
              ></gl-icon>
            }
            @if (workSpace.cargoSpaces[0].type === 4) {
              <gl-icon
                [name]="'airContainer'"
                class="vehicle"
              ></gl-icon>
            }
            @if (workSpace.cargoSpaces[0].type > 4) {
              <gl-icon
                [name]="'type-other'"
                class="vehicle"
              ></gl-icon>
            }
          </div>
          @if (workSpace.cargoSpaces[1]) {
            <div class="listTitle">
              @if (workSpace.cargoSpaces[cargoSpaceIndex].type === 1) {
                <div>
                  {{ (cargoSpaceIndex === 0 ? 'semi_trailer' : 'trailer') | translate }}
                </div>
              }
              @if (workSpace.cargoSpaces[cargoSpaceIndex].type === 2) {
                <div>
                  {{ 'container' | translate }} {{ cargoSpaceIndex === 0 ? '1' : '2' }}
                </div>
              }
              @if (workSpace.cargoSpaces[cargoSpaceIndex].type === 3) {
                <div>
                  {{ 'space' | translate }} {{ cargoSpaceIndex === 0 ? '1' : '2' }}
                </div>
              }
            </div>
          }
        </div>
      }
      <div>
        <span data-ctx="label-cargo-space-name" class="cargoSpaceName">{{ workSpace.cargoSpaces[0].name | indexedName }}</span>
      </div>
    </div>
    @if (cargoSpaceIndex === 0) {
      <div class="iconWrapper">
        @if (showPalletQuantityCounter && !isMobile && !isSharedView) {
          <div
            class="edit palletQuantityStepper"
            data-ctx="pallet-space-quantity-stepper"
            (click)="$event.stopPropagation()"
          >
            <span data-ctx="button-minus-pallet-quantity" (click)="decrementPalletQuantity($event)">-</span>
            <div data-ctx="pallet-space-quantity">{{ displayedPalletQuantity() }}</div>
            <span data-ctx="button-plus-pallet-quantity" (click)="incrementPalletQuantity($event)">+</span>
          </div>
        }
        @if (showPalletQuantityCounter && (isMobile || isSharedView)) {
          <div class="quantity" data-ctx="pallet-space-quantity">{{ displayedPalletQuantity() }}</div>
        }
        <gl-icon
          [name]="'undo'"
          class="undo"
          data-ctx="button-show-loads"
          [class.undoOpen]="!isClosed"
          (click)="onShowLoads(workSpaceIndex, $event)"
        ></gl-icon>
        @if (!isMobile) {
          <button
            [class.overlay]="isSharedView"
            icon-button
            (click)="editLoadingSpace($event)"
            #editTrigger
            data-ctx="button-edit-loading-space"
            >
            <gl-icon class="moreIcon" [name]="'more'"></gl-icon>
          </button>
        }
      </div>
    }
  </div>
</div>
@if (edit) {
  <gl-loading-space-edit
    [currentWorkSpaceId]="workSpace.id"
    [cargoSpaces]="workSpace.cargoSpaces"
    (glMousedownOutside)="onCloseEditLoadingSpace()"
    (closeEditEmitter)="onCloseEditLoadingSpace()"
    [elementToIgnore]="editTriggerEl"
    (isMoreOpen)="moreOpen($event)"
    #editwindow
  ></gl-loading-space-edit>
}
